<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.lotnumber') }} > {{ $t('sidebar.all') }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right col-8 pl-0">
        <div class="action">
          <div class="dropdown item dropdown-filter">
            <button
              class="btn no-bg text-secondary dropdown-toggle filter"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              <i class="fas fa-filter"/>
              {{ $t('message.filter') }}
              <template>
                <span
                  v-if="query.status == null"
                  class="badge badge-secondary">{{ $t('message.all') }}</span>
                <span
                  v-if="query.status == 'ready'"
                  class="badge badge-success">{{ $t('apps.inventory.message.lotready') }}</span>
                <span
                  v-if="query.status == 'notready'"
                  class="badge badge-warning">{{ $t('apps.inventory.message.lotnotready') }}</span>
                <span
                  v-if="query.status == 'empty'"
                  class="badge badge-light">{{ $t('apps.inventory.message.lotempty') }}</span>
              </template>
              <template v-if="query.wh_id">
                <span class="badge badge-secondary">{{ getWarehouseInfo(query.wh_id).warehouse_name }}</span>
              </template>
              <template v-if="query.bin_id">
                <span class="badge badge-secondary">{{ getBinName(query.bin_id) }}</span>
              </template>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <form
                class="px-3 py-2"
                style="min-width: 300px;">
                <div class="form-group">
                  <label>{{ $t('apps.inventory.message.lotstatus') }}</label>
                  <BaseDropdown
                    v-model="query.status"
                    :classNames="['form-control-sm']"
                    :options="statusOptions"
                    @change="handleFilterChange"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('message.store') }}</label>
                  <BaseDropdown
                    v-model="query.wh_id"
                    :classNames="['form-control-sm']"
                    :options="whOptions"
                    @change="handleFilterChange"
                  />
                </div>
                <div class="form-group mb-0">
                  <label>{{ $t('apps.inventory.message.bin') }}</label>
                  <BaseDropdown
                    v-model="query.bin_id"
                    :classNames="['form-control-sm']"
                    :options="binOptions"
                    :disabled="!query.wh_id"
                    @change="handleFilterChange"
                  />
                </div>
              </form>
            </div>
          </div>
          <div
            v-if="hasRoleCreate"
            class="dropdown nodro item">
            <button
              class="btn no-bg text-secondary"
              type="button"
              @click="openModalImportLot()"
            >
              <i class="fas fa-file-download"/>
              <span class="name">{{ $t('button.importlot') }}</span>
            </button>
          </div>
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <div
        class="row"
        style="margin-bottom: 12px;">
        <div class="col-lg-4 ml-auto">
          <label class="d-flex d-flex align-items-center">
            <span class="mr-2">
              {{ $t('message.search') }}:
            </span>
            <BaseInput
              v-model="query.q"
              :placeholder="$t('placeholder.searchstock')"
              type="text"
              clear
              @onEnter="handleSearchEnter"
              @onClear="handleSearchClear"
            />
          </label>
        </div>
      </div>
      <base-table
        :pagination="pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 160px;">{{ $t('series.lot') }}</th>
              <th>{{ $t('apps.inventory.message.product') }}</th>
              <!-- <th>{{ $t('apps.inventory.message.ref') }}</th> -->
              <th>{{ $t('apps.inventory.message.warehouse') }}</th>
              <th>{{ $t('apps.inventory.message.bin') }}</th>
              <th>
                <base-sort-label
                  v-model="sort.date_in"
                  @onChange="handleSortChange($event, 'date_in')"
                >
                  {{ $t('apps.inventory.message.datein') }}
                </base-sort-label>
              </th>
              <th>
                <base-sort-label
                  v-model="sort.date_product"
                  @onChange="handleSortChange($event, 'date_product')"
                >
                  {{ $t('apps.inventory.message.dateproduct') }}
                </base-sort-label>
              </th>
              <th>
                <base-sort-label
                  v-model="sort.date_expire"
                  @onChange="handleSortChange($event, 'date_expire')"
                >
                  {{ $t('apps.inventory.message.dateexpire') }}
                </base-sort-label>
              </th>
              <th>
                <base-sort-label
                  v-model="sort.unit_balance"
                  @onChange="handleSortChange($event, 'unit_balance')"
                >
                  {{ $t('apps.inventory.message.totalbanalce') }}
                </base-sort-label>
              </th>
              <th>
                <base-sort-label
                  v-model="sort.cost"
                  @onChange="handleSortChange($event, 'cost')"
                >
                  {{ $t('apps.inventory.message.cost') }}
                </base-sort-label>
              </th>
              <th>{{ $t('apps.inventory.message.lotstatus') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="empty"
                colspan="11"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in data"
              :key="index"
            >
              <td>
                <router-link
                  :to="{
                    name: 'InventoryLotEdit',
                    query: {
                      id: item.lotId,
                      code: item.lotCode,
                    }
                }">
                  {{ item.lotCode }}
                </router-link>
              </td>
              <td>
                <span class="badge badge-secondary">
                  {{ getProductFullName(item.product.productName, item.sku.attributes) }}
                </span>
              </td>
              <!-- <td>
                -
              </td> -->
              <td>
                {{ item.warehouse.warehouseName }}
              </td>
              <td>
                {{
                  item.warehouse.binLocations.reduce((acc, cur) => {
                    if(cur.id === item.binLocationId) {
                      acc = cur.code
                    }
                    return acc
                  }, null)
                }}
              </td>
              <td>
                {{ item.dateIn ? getDate(item.dateIn) : null }}
              </td>
              <td>
                {{ item.dateProduct ? getDate(item.dateProduct) : null }}
              </td>
              <td>
                {{ item.dateExpire ? getDate(item.dateExpire) : null }}
              </td>
              <td>
                {{ item.unitBalance }}/{{ item.unitInit }}
              </td>
              <td>
                {{ getNumber(item.cost) }}
              </td>
              <td>
                <span
                  v-if="item.unitBalance <= 0"
                  class="text-grey">
                  {{ $t('apps.inventory.message.lotempty') }}
                </span>
                <template v-else>
                  <span
                    v-if="item.isReady"
                    class="text-success">{{ $t('apps.inventory.message.lotready') }}</span>
                  <span
                    v-else
                    class="text-warning">{{ $t('apps.inventory.message.lotnotready') }}</span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

      <BaseModalImportLot
        :id="MODAL_IMPORT_LOT"
        :isSubmitted="isSubmittedImport"
        @onClose="handleCloseImportLot"
        @onSubmit="handleSubmitImportLot"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import userPermissionMixin from '@/mixins/userPermission'
import BaseModalImportLot from '@/components/base/BaseModalImportLot'
import { delay } from '@/helpers'

export default {
  components: {
    BaseModalImportLot,
  },

  mixins: [tablePaginateMixin, userPermissionMixin],

  data () {
    return {
      MODAL_IMPORT_LOT: 'MODAL_IMPORT_LOT',
      loading: true,
      query: {
        page: this.$route.query.page,
        q: this.$route.query.q || null,
        status: this.$route.query.status || null,
        wh_id: this.$route.query.wh_id || null,
        bin_id: this.$route.query.bin_id || null,
        sort_value: this.$route.query.sort_value || null,
        sort_key: this.$route.query.sort_key || null,
      },
      sort: {
        date_in: null,
        date_product: null,
        date_expire: null,
        unit_balance: null,
        cost: null,
      },
      isSubmittedImport: false,
    }
  },

  computed: {
    ...mapState('lot', {
      data: 'lotList',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
      warehouses: 'getWarehouses',
      getWarehouseInfo: 'getWarehouseInfo',
      getBinName: 'getBinName',
    }),
    defaultOption () {
      return {
        text: this.$t('message.all'),
        value: null,
      }
    },
    statusOptions () {
      return [
        { ...this.defaultOption },
        {
          text: this.$t('apps.inventory.message.lotready'),
          value: 'ready',
        },
        {
          text: this.$t('apps.inventory.message.lotnotready'),
          value: 'notready',
        },
        {
          text: this.$t('apps.inventory.message.lotempty'),
          value: 'empty',
        },
      ]
    },
    whOptions () {
      const items = this.warehouses.map((wh) => {
        return {
          text: wh.warehouse_name,
          value: wh.warehouse_id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
    binOptions () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.query.wh_id) {
          const bins = cur.bin_locations.map((bin) => {
            return {
              text: bin.code,
              value: bin._id,
            }
          })
          if (bins.length) {
            acc.push(...bins)
          }
        }
        return acc
      }, [])
      return [{ ...this.defaultOption }, ...items]
    },
  },

  watch: {
    warehouses () {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 6,
        submenuAtIdx: 0,
      })
    },
    'query': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
      },
      deep: true,
    },
    'query.wh_id': {
      handler: function () {
        this.query.bin_id = null
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = null
        this.query.q = null
        this.query.status = null
        this.query.wh_id = null
        this.query.bin_id = null
        this.query.sort_key = null
        this.query.sort_value = null
        this.fetchData()
      }
    },
  },

  async created () {
    this.fetchData()
    if (this.query.sort_key && this.query.sort_value) {
      this.sort[this.query.sort_key] = this.query.sort_value
    }
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 7,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 6,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('lot', {
      getLotList: 'getLotList',
      createLot: 'createLot',
    }),
    getFilter () {
      const filter = {}
      if (this.query.status === 'ready') {
        filter['filter[is_ready]'] = 'true'
        filter['filter[unit_balance_empty]'] = 'false'
      } else if (this.query.status === 'notready') {
        filter['filter[is_ready]'] = 'false'
      } else if (this.query.status === 'empty') {
        filter['filter[unit_balance_empty]'] = 'true'
      }
      if (this.query.wh_id) {
        filter['filter[wh_id]'] = this.query.wh_id
      }
      if (this.query.bin_id) {
        filter['filter[bin_location_id]'] = this.query.bin_id
      }
      return filter
    },
    getSort () {
      const sort = {}
      if (this.query.sort_key && this.query.sort_value) {
        sort['sort[key]'] = this.query.sort_key
        sort['sort[value]'] = this.query.sort_value
      }
      return sort
    },
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.$store.dispatch('getWarehouses')
      await this.$store.dispatch('getProducts')
      await this.getLotList({
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        q: this.query.q,
        ...this.getFilter(),
        ...this.getSort(),
      })
      this.loading = false
      this.showFinish(this.$Progress)
    },
    handleFilterChange () {
      this.fetchData()
    },
    handleSortChange (sortValue, sortKey) {
      for (const key of Object.keys(this.sort)) {
        if (key !== sortKey) {
          this.sort[key] = null
        }
      }
      this.query.page = null
      this.query.sort_key = sortKey
      this.query.sort_value = sortValue
      this.fetchData()
    },
    handleSearchEnter () {
      this.query.page = undefined
      this.fetchData()
    },
    handleSearchClear () {
      this.query.page = undefined
      this.query.q = undefined
      this.fetchData()
    },
    openModalImportLot() {
      $(`#${this.MODAL_IMPORT_LOT}`).modal('show')
    },
    handleCloseImportLot() {
      $(`#${this.MODAL_IMPORT_LOT}`).modal('hide')
    },
    async handleSubmitImportLot(form, callback) {
      this.isSubmittedImport = true
      let successCount = 0
      for (const payload of form) {
        const response = await this.createLot(payload)
        if (response.success) {
          successCount++
        }
        await delay(1000)
      }
      $(`#${this.MODAL_IMPORT_LOT}`).modal('hide')
      this.notify(this.$vs, {
        text: this.$t('message.importdatasuccess', { number: successCount }),
        color: 'success',
        icon: 'cloud',
      })
      this.isSubmittedImport = false
      callback()
      this.fetchData()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/lotnumber/List.vue